import { render, staticRenderFns } from "./EstoqueNotaFiscal.vue?vue&type=template&id=bcbd0dac&scoped=true&"
import script from "./EstoqueNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./EstoqueNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueNotaFiscal.vue?vue&type=style&index=0&id=bcbd0dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd0dac",
  null
  
)

export default component.exports